import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
  gql,
} from '@apollo/react-hooks';

export const useConfirmCoSupDec = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [confirmCoSupDec] = useMutation(
    gql`
      mutation (
        $nominationId: String!
        $emailAddress: String!
        $confirmed: Boolean!
        $coSupervisorDeclarationRemark: String
      ) {
        confirmCoSupervisorDeclaration(
          nominationId: $nominationId
          emailAddress: $emailAddress
          confirmed: $confirmed
          coSupervisorDeclarationRemark: $coSupervisorDeclarationRemark
        )
      }
    `,
    {},
  );
  return confirmCoSupDec;
};
